<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="$i18n.locale = localeObj.locale"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { AVAILABLE_LOCALES } from '@/libs/i18n'
import { watch, computed, getCurrentInstance } from '@vue/composition-api'
export default {
    setup () {
        const vm = getCurrentInstance().proxy
        const locales = AVAILABLE_LOCALES
        const currentLocale = computed(() => locales.find(l => l.locale === vm.$i18n.locale))
        watch(currentLocale, (value) => {
            localStorage.setItem('locale', value.locale)
        })
        return {
            locales,
            currentLocale
        }
    }
}
</script>

<style>

</style>
